import { createAction } from 'redux-actions'

export const setGBBDetails = createAction('GBB_DETAILS/ADD_GBB_DETAILS')
export const setGBBAvailability = createAction('GBB_DETAILS/ADD_GBB_AVAILABILITY')
export const setGBBTireSize = createAction('GBB_DETAILS/ADD_GBB_TIRE_SIZE')
export const setGBBStoreNumber = createAction('GBB_DETAILS/ADD_GBB_STORE_NUMBER')
export const setAllGBBDetails = createAction('GBB_DETAILS/ADD_ALL_GBB_DETAILS')
export const clearGBBDetails = createAction('GBB_DETAILS/CLEAR_FROM_STORE')
